<div class="filtro-select-busca">
  <button type="button" class="select-toggle" (click)="toggle()">
    <span class="rotulo" [class.sem-selecao]="!temSelecao">{{ rotuloSelecionado }}</span>
    <mat-icon>expand_more</mat-icon>
  </button>

  <div class="dropdown-list" *ngIf="aberto" (click)="$event.stopPropagation()">
    <div class="dropdown-busca">
      <mat-icon>search</mat-icon>
      <input
        type="text"
        [(ngModel)]="termoBusca"
        [placeholder]="placeholderBusca"
        autocomplete="off"
      />
      <button
        *ngIf="termoBusca"
        type="button"
        class="btn-limpar-busca"
        title="Limpar busca"
        (click)="termoBusca = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="dropdown-opcoes">
      <button
        *ngFor="let option of opcoesFiltradas"
        type="button"
        class="opcao"
        [class.selecionada]="option.value === value"
        (click)="selecionar(option)"
      >
        {{ option.label }}
      </button>

      <p class="sem-resultado" *ngIf="!opcoesFiltradas.length">
        Nenhum resultado encontrado.
      </p>
    </div>
  </div>
</div>
